module.exports = __webpack_public_path__ + "img/news1-3.6f056ca2.png";